import { Ref, watch } from 'vue';
import { FieldHtmlNameUtil, HekateDisplayForm } from 'www-shared';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class WebinarRegistrationProgressiveProfile extends CommonPreFilledProgressiveProfile {
  // eslint-disable-next-line class-methods-use-this
  public realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    if (!formDefinition.value) {
      return;
    }
    super.realtimeBranchModifications({ formDefinition });

    const cadExperienceField = ExternalUtil.findDisplayFieldOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.whatIsYourExperience });
    cadExperienceField.componentName = 'hidden-field';
    const formVariantFieldVal = ExternalUtil.findDisplayFieldValOrThrow({ formDefinition, fieldName: FieldHtmlNameUtil.formVariant });

    watch(formVariantFieldVal, (newVal) => {
      if (newVal === 'QualifyingQuestion') {
        cadExperienceField.componentName = 'single-select-field';
      }
    });
  }
}
